import React, { useEffect } from 'react';
// import { initGA } from './index';

import Root from './root';
import './App.css';

const App: React.FC = (props) => {
    // useEffect(() => { initGA(); }, []);
    return (
        <Root />
    );
};

export default App;
